import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Box from 'components/common/Box'
import Overlay from 'components/common/Overlay'
import Text from 'components/common/Text'

import styles from './ErrorModal.module.css'

const ErrorModal = ({ children, className, title, ...props }) => (
    <Overlay className={styles.wrapper} {...props}>
        <Box className={cx(styles.box, className)}>
            {title && <Text className={styles.title}>{title}</Text>}
            {children}
        </Box>
    </Overlay>
)

ErrorModal.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string,
}

export default ErrorModal
